import { Link } from "react-router-dom";
import { GraduationCap, Users, MonitorPlay, ArrowLeft } from "lucide-react";

export default function Training() {
    return (
        <main className="min-h-screen bg-gradient-to-b from-indigo-700 via-indigo-600 to-violet-600 px-6 py-12 flex justify-center">
            <div className="w-full max-w-5xl bg-white rounded-2xl shadow-xl p-8">
                <div className="flex items-center gap-3 mb-6">
                    <img src="/Images/ExamsPro.png" alt="ExamsPro" className="w-10 h-10" />
                    <h1 className="text-2xl font-bold text-indigo-700">Training</h1>
                </div>

                <p className="text-gray-600 mb-8">
                    We offer hands-on training programs for administrators, proctors, and test authors to master ExamsPro.
                </p>

                <section className="grid md:grid-cols-2 gap-6">
                    <div className="rounded-xl border border-indigo-100 p-6">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <GraduationCap className="w-5 h-5" />
                            <h3 className="font-semibold">Admin Training</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>� Test setup and configuration</li>
                            <li>� Candidate enrollment management</li>
                            <li>� Result export and analytics</li>
                        </ul>
                    </div>

                    <div className="rounded-xl border border-indigo-100 p-6">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <MonitorPlay className="w-5 h-5" />
                            <h3 className="font-semibold">Proctor Certification</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>� Exam monitoring procedures</li>
                            <li>� ID validation and biometric handling</li>
                            <li>� Incident documentation</li>
                        </ul>
                    </div>
                </section>

                <div className="mt-10 flex flex-wrap justify-center gap-4">
                    <Link to="/contact" className="bg-indigo-600 text-white px-5 py-2.5 rounded-full font-semibold hover:bg-indigo-700 transition">
                        Enroll in Training
                    </Link>
                    <Link to="/solutions/examspro" className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-700 hover:bg-indigo-200 px-5 py-2.5 rounded-full font-semibold transition">
                        <ArrowLeft className="w-4 h-4" /> Back to ExamsPro
                    </Link>
                </div>
            </div>
        </main>
    );
}
